import React, { useEffect } from "react";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import Text from "@components/Text";
import { themeDefault } from "src/theme-revamp";
import Button from "@components/_Revamp/Button";

export interface IEditModalData {
  title: string;
  onBackClick: () => void;
  onProceedClick: () => void;
}
export interface EditModalProps {
  data?: IEditModalData | null;
}

function EditModal({ ...props }: EditModalProps) {
  return (
    <Container>
      <FormHeaderContainer>
        <FormHeaderTitleContainer marginHorizontal={"0px"}>
          <Text
            align={"center"}
            theme={themeDefault}
            className={HeaderTitleCss}
          >
            Need to make changes?
          </Text>
        </FormHeaderTitleContainer>
        <FormHeaderDescriptionContainer>
          <Text theme={themeDefault} className={HeaderDescriptionCss}>
            We will take you to the previous section but fret not, our system
            has retained the information you keyed in earlier.
          </Text>
        </FormHeaderDescriptionContainer>
      </FormHeaderContainer>
      <FormContentContainer>
        <Button
          onClick={() => {
            if (props?.data?.onBackClick) {
              props.data.onBackClick();
            }
          }}
          width={"200px"}
          variant={"secondary"}
          theme={themeDefault}
          label={"Back"}
        ></Button>
        <Button
          onClick={() => {
            if (props?.data?.onProceedClick) {
              props.data.onProceedClick();
            }
          }}
          width={"200px"}
          variant={"default"}
          theme={themeDefault}
          label={"Proceed"}
        ></Button>
      </FormContentContainer>
    </Container>
  );
}

export default EditModal;

const Container = styled.div``;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  color: #434343;
  font-size: 20px;
  @media screen and (min-width: 768px) {
    font-size: 28px;
  }
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 48px;
`;
const FormContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  column-gap: 30px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: space-evenly;
    row-gap: 10px;
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0 0px;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (min-width: 768px) {
    font-weight: 600;
  }
`;

export interface FormContainerProps {
  margin?: string;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
